import styled from 'styled-components';

export const CitizenPageShell = styled.div`
  display: grid;
  gap: 18px;
  width: 100%;
`;

export const CitizenPanel = styled.section`
  box-sizing: border-box;
  padding: 24px 28px;
  border-radius: ${(p) => p.theme.radii.lg};
  background: ${(p) => p.theme.colors.light};

  @media (max-width: 639px) {
    padding: 20px 12px 24px;
    border-radius: 12px;
  }
`;

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;

  @media (max-width: 639px) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const SearchInput = styled.input`
  width: min(100%, 320px);
  height: 40px;
  padding: 0 12px;
  border: 1px solid ${(p) => p.theme.colors.gray100};
  border-radius: ${(p) => p.theme.radii.base};
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};

  @media (max-width: 639px) {
    width: 100%;
  }
`;

export const CitizenTableScroll = styled.div`
  width: 100%;
  overflow-x: auto;

  @media (max-width: 639px) {
    overflow: visible;
  }
`;

export const CitizenTable = styled.table`
  width: 100%;
  min-width: 780px;
  border-collapse: collapse;

  th,
  td {
    padding: 12px 10px;
    border-bottom: 1px solid ${(p) => p.theme.colors.gray100};
    color: ${(p) => p.theme.colors.gray500};
    font-size: ${(p) => p.theme.fontSizes.sm};
    text-align: left;
    vertical-align: top;
  }

  th {
    color: ${(p) => p.theme.colors.gray300};
    font-weight: 500;
  }

  @media (max-width: 639px) {
    display: block;
    min-width: 0;

    thead {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    tbody {
      display: grid;
      gap: 12px;
    }

    tbody tr {
      display: block;
      padding: 18px 12px;
      border-radius: 12px;
      background: ${(p) => p.theme.colors.light};
    }

    tbody tr:nth-child(odd) {
      background: ${(p) => p.theme.colors.gray000};
    }

    th,
    td {
      padding: 4px 0;
      border: 0;
      font-size: 14px;
      line-height: 1.3;
    }

    td {
      display: grid;
      grid-template-columns: 108px minmax(0, 1fr);
      gap: 12px;
      overflow-wrap: anywhere;
    }

    td::before {
      content: attr(data-label);
      color: ${(p) => p.theme.colors.gray300};
    }

    td:last-child button {
      width: 100%;
      min-height: 36px;
    }
  }
`;

export const EmptyText = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.gray300};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 10px 28px;

  @media (max-width: 768px) {
    grid-template-columns: 121px minmax(0, 1fr);
    gap: 8px 12px;
  }
`;

export const DetailLabel = styled.div`
  color: ${(p) => p.theme.colors.gray300};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const DetailValue = styled.div`
  min-width: 0;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 16px;
  color: ${(p) => p.theme.colors.primary500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
`;

export const InlineActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 639px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    button {
      width: 100%;
    }
  }
`;

